import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Container, Grid } from '@hbf/dsl';
import {
  LISTING_DETAIL_PAGE,
  SOMETHING_WENT_WRONG,
} from 'ha/constants/pageNames';
import { Page } from 'ha/modules/Page';
import { Img } from 'ha/ui/Img';
import { Link } from 'ha/ui.legacy/Link';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';

import MapIcon from 'ha/img-src/map-icon.png';

interface Props {
  listingId: number;
}

const useStyles = makeStyles()(theme => ({
  background: {
    backgroundColor: theme.palette.grey['700'],
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    textAlign: 'center',
  },
}));

const ListingErrorLayout: React.FC<Props> = ({ listingId }) => {
  const { classes } = useStyles();

  return (
    <Page
      key={`${LISTING_DETAIL_PAGE} ${SOMETHING_WENT_WRONG} ${listingId}`}
      name={SOMETHING_WENT_WRONG}
      category={LISTING_DETAIL_PAGE}
      statusCode={500}
    >
      <div className={classes.background}>
        <Container className={classes.container}>
          <Grid container>
            <Grid item xs={12} md={6}>
              <Track
                name="Clicked Map marker anchor in photo previews"
                type="button"
              >
                <Link to="#map" data-test-locator="Listing no photos">
                  <Img src={MapIcon} role="presentation" />
                </Link>
              </Track>
            </Grid>
          </Grid>
        </Container>
      </div>
    </Page>
  );
};

export { ListingErrorLayout };
